import { mapGetters, mapActions } from 'vuex';

const emptyObject = {};

export default {
  computed: {
    ...mapGetters('entities', {
      noteEntities: 'notes',
    }),
    ...mapGetters('dashboard/job', [
      'currentJobNotesMeta',
      'currentRawJobNotes',
    ]),
    note () {
      return this.noteEntities[this.noteId] || emptyObject;
    },
  },
  methods: {
    ...mapActions('dashboard/job', [
      'fetchNotes',
      'createOrUpdateNotes',
      'deleteNotes',
    ]),
  },
};
